import React, { useState, useEffect } from 'react';

import { Modal } from 'antd';
import ClientList from 'components/lists/ClientList';
import ClientForm, {
  addClient,
  deleteClient,
  desactivateClient,
  editClient,
} from 'components/forms/ClientForm';
import EliminarForm from 'components/forms/EliminarForm';
import { useGetToApi } from 'hooks/useApi/useGetAxios';
import ProblemsClientList from 'components/lists/ProblemsClientList';

const defaultModalProps = {
  children: null,
  title: 'Error',
  open: false,
};

function Client() {
  const [modalProps, setModalProps] = useState(defaultModalProps);
  const [clients, isLoadingClients, callClients] = useGetToApi('/client/all', {
    config: {
      params: { whitProblems: true },
    },
    initialValues: {
      data: [],
    },
  });

  const successFinish = () => {
    callClients();
    setModalProps(defaultModalProps);
  };

  const openDeleteClient = async (client) => {
    setModalProps({
      open: true,
      children: (
        <EliminarForm
          title="Eliminar Cliente"
          id={client.id}
          desactivate={(id) => desactivateClient(id, successFinish)}
          deleteRegister={(id) => deleteClient(id, successFinish)}
        />
      ),
    });
  };

  const openEditClient = async (client) => {
    setModalProps({
      open: true,
      children: (
        <ClientForm
          buttonLabel="Editar"
          submitForm={(values) => editClient(values, client.id, successFinish)}
          formProps={{
            initialValues: client,
          }}
        />
      ),
      title: 'Editar Cliente',
    });
  };

  const openAddClient = () => {
    setModalProps({
      open: true,
      children: (
        <ClientForm
          buttonLabel="Agregar"
          submitForm={(values) => addClient(values, successFinish)}
        />
      ),
      title: 'Agregar Cliente',
    });
  };
  const getClientProblems = async (client) => {
    setModalProps({
      open: true,
      children: (
        <ProblemsClientList client={client} openEditClient={openEditClient} />
      ),
      title: 'ELEMENTOS FALTANTES DEL CLIENTE ',
    });
  };

  useEffect(() => {
    callClients();
  }, [callClients]);

  return (
    <div>
      <ClientList
        openEditClient={openEditClient}
        openDeleteClient={openDeleteClient}
        getClientProblems={getClientProblems}
        openAddClient={openAddClient}
        clients={clients.data}
        isLoading={isLoadingClients}
        refresh={callClients}
      />
      <Modal
        {...modalProps}
        footer={false}
        onCancel={() => setModalProps(defaultModalProps)}
      />
    </div>
  );
}

export default Client;
